var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeeAllChevronIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58586 5.49617L0.505101 2.41541C0.387944 2.29825 0.387943 2.1083 0.505101 1.99114L1.49505 1.00119C1.61221 0.884037 1.80216 0.884037 1.91931 1.00119L5.61931 4.70119C5.67558 4.75746 5.70718 4.83376 5.70718 4.91333V6.07901C5.70718 6.15858 5.67558 6.23488 5.61931 6.29114L1.91931 9.99114C1.80216 10.1083 1.61221 10.1083 1.49505 9.99114L0.505101 9.00119C0.387943 8.88404 0.387943 8.69409 0.5051 8.57693L3.58586 5.49617Z",
    fill: "white",
    fillOpacity: 0.56
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeAllChevronIcon);
export default __webpack_public_path__ + "static/media/see-all-chevron-icon.bb409c867bcc56faefd629e4f834e0a9.svg";
export { ForwardRef as ReactComponent };